import { css } from 'styled-components';
import { FontAddiFamilySecondaryName, FontAddiFormatTrueType, FontAddiFamilySecondaryUrlRegular, FontAddiFamilySecondaryUrlBold, FontAddiFamilySecondaryUrlBoldItalic, FontAddiFamilySecondaryUrlItalic, FontAddiWeightSemiBold, FontAddiWeightBold, FontAddiWeightMedium, FontAddiWeightRegular, FontAddiWeightExtraBold, FontAddiWeightLight, FontAddiWeightExtraLight, FontAddiWeightThin, } from '@addi/foundation/dist/web/fonts';
const SecondaryFontFaces = css `

    /* Secondary - Normal */
    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightRegular};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightSemiBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightMedium};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightLight};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraLight};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightThin};
        font-style: normal;
        font-display: swap;
    }

    /* Secondary - Italic */
    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightRegular};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightSemiBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightMedium};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightLight};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraLight};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilySecondaryName}';
        src: url(${FontAddiFamilySecondaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightThin};
        font-style: italic;
        font-display: swap;
    }

`;
export const secondaryFontFamilyURLs = [
    FontAddiFamilySecondaryUrlRegular,
    FontAddiFamilySecondaryUrlBold,
    FontAddiFamilySecondaryUrlBoldItalic,
    FontAddiFamilySecondaryUrlItalic
];
export default SecondaryFontFaces;
//# sourceMappingURL=Secondary.js.map